// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.tsx';

// react-grid-layout → react-draggable reads `process.env.DRAGGABLE_DEBUG`,
// which throws "process is not defined" in the browser when you start a drag.
// Vite already inlines NODE_ENV at build time, so this minimal shim is safe
// and only provides the missing `process.env` object the lib expects.
{
  const g = globalThis as unknown as { process?: { env: Record<string, unknown> } };
  if (typeof g.process === 'undefined') {
    g.process = { env: {} };
  }
}

// Initialize theme from storage
const initTheme = () => {
  const root = document.documentElement;
  root.classList.remove('light', 'dark');

  const stored = localStorage.getItem('ui-storage');
  let theme = 'light'; // Default to light

  if (stored) {
    try {
      const { state } = JSON.parse(stored);
      theme = state?.theme || 'light';
    } catch {
      // Ignore parse errors
    }
  }

  if (theme === 'system') {
    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
    root.classList.add(systemTheme);
  } else {
    root.classList.add(theme);
  }
};

initTheme();

createRoot(document.getElementById('root')!).render(
  // TODO: re-enable StrictMode after fixing WebSocket double-invoke
  // <StrictMode>
    <App />
  // </StrictMode>
);
